<template>
   <div class="container-area my-10">
        <div v-if="imageFull" class="image-full">
          <div @click="imageFull=null" class="back-box"></div>
          <div class="img">
            <div @click="imageFull=null" class="close-icon abs-ico">
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
            <img :src="imageFull" alt="">
          </div>
      </div>
        <div class="chat-container">
            <div v-if="chatIsShowed" class="chat-box">
                <div class="fake-side"></div>
                <div class="left-box" :class="{ moveleft:responsive}">
                    <div class="chat-head">
                        <div class="responsive-icon" @click="responsive=!responsive">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </div>
                        <div class="search-box">
                            <label class="label-search">
                                <input type="text" dir="auto" v-model="visitorsSearchKey" :placeholder="'livechat_search'">
                            </label>
                        </div>
                         <div class="check-filter-container" >
                            <label for="toggleB" class="pl-5 flex items-center cursor-pointer">
                                <div class="relative">
                                    <input type="checkbox" id="toggleB" class="check-filter" v-model="checkedFilter"/>
                                    <div class="check-filter-c" :class="checkedFilter?'bg-color-true':'bg-color-false'"></div>
                                    <div class="check-filter-rounded" :class="checkedFilter?'rounded-right':'rounded-left'" ></div>
                                </div>
                            </label>
                        </div>
                    </div>                        
                    <div class="contacts-box scroll-box">
                        <div class="contact" :class="{active:currentVisitorKey === visitor.key}" v-for="(visitor,index) in currentVisitors" :style="visitor.data.done?'background:#c4f5c4;':''" :key="index+'tr'">
                           <div class="contact-box" @click="openVisitor(JSON.stringify(visitor.key))">
                            <div class="profile-image">
                                <div class="default-iamge" v-if="visitor.data.username">
                                       {{visitor.data.username.substring(0,1).toUpperCase()}}
                                </div>
                                <div class="account-status"></div>
                            </div>
                            <div class="contact-details">
                                <div class="contact-data">
                                    <p class="contact-name">{{visitor.data.username}}
                                    </p>
                                    <p class="contact-last-message" :class="{'fw-b':visitor.count>0}" >
                                        <span v-if="visitor.lastMessage.fromAdmin">
                                           <svg  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </span>
                                        <span>
                                            <span v-if="visitor.data.focused && visitor.data.focused.isFocused" :title="visitor.data.focused.focusedBy" class="focused">{{visitor.data.focused.focusedType=='text'?'Typing...':'Recording'}}</span>
                                            <span v-else> {{visitor.lastMessage.msg}} </span>
                                        </span>
                                    </p>
                                </div>
                                <div  v-if="visitor.data.warehouse"> <img width="20" height="20" :src="visitor.data.warehouse.flag" alt=""></div>
                                <div class="contact-news-box">
                                    <span v-if="visitor.count>0" class="news-count">{{visitor.count}}</span>
                                    <span v-if="visitor.lastMessageTime" class="news-time">{{getTime(visitor.lastMessageTime)}} </span>
                                </div> 
                            </div>
                           </div>
                            <div class="options">
                                <button title="marquer" :class="{'marked':visitor.data.isMarked}" class="checkbox" @click="changeCheck(visitor.key)">
                                </button>
                                <button v-if="false" title="suprimer"  class="remo checkbox" @click="customRemove(visitor.key)">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="right-box">
                    <div @click="responsive=true" class="responsive-back-Box" v-if="!responsive"> </div>
                    <div class="visitor-box" @click="messagesReaded(currentVisitor.key)">
                        <div class="current-chat" v-if="currentVisitor.data">
                            <div class="flex">
                                <div class="hidding-space" v-if="responsive"></div>
                                <div class="profile-image">
                                    <div  class="default-iamge">
                                       <p v-if="currentVisitor.data.username">
                                           {{currentVisitor.data.username.substring(0,1).toUpperCase()}}
                                        </p>
                                  </div>
                                </div>
                                <span class="ws-4"></span>
                                <div class="chat-title">
                                    <span class="title-name">{{currentVisitor.data.username}}</span>
                                </div>
                                <span class="ws-4"></span>

                            </div>
                            <div @click="conversationTerminer(currentVisitor.key)" class="flex items-center justify-center st py-1 px-5  cursor-pointer" :style="currentVisitor.data.done?'background:blue;color:#ffff;':'color: green;'" >
                               <span class="flex mx-1 relative">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 absolute " style="left:4px;" viewBox="0 0 20 20" fill="currentColor">
                                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                </svg>
                               </span>
                             <span  class="text-sm mx-1">Done</span>
                            </div>
                            <div class="flex flex-right">
                                <div class="search-box">
                                <label class="label-search">
                                    <input type="text" dir="auto" v-model="messagesSearchKey" :placeholder="'livechat_search'">
                                </label>
                            </div>
                            </div>
                        </div>
                        <div id="messages-scroll-box" class="messages-box scroll-box">
                            <div class="msg" v-for="(item,index) in currentMessages" :key="index">
                             <Message  :item="item" :position="item.admin ?'rightfollow':'leftfollow'" v-on:showImg="showImg($event)" v-on:remove="deleteMessage($event)"/>
                            </div>
                            <div v-if="uploadedImages.length>0" class="uploader-image">
                                <div class="images-slied scroll-box">
                                    <img v-for="(img, index) in uploadedImages" :key="index" :src="img" alt="uploaded image">
                                </div>
                                <div class="actions">
                                    <div @click="closePopImg()" class="close-icon">
                                        <span class="bar"></span>
                                        <span class="bar"></span>
                                    </div>

                                <button @click.prevent="sendMessage('image')" v-if="true" class="send-button send-button-img">
                                    <span v-html="getsvg('sendBtn')"></span>
                                </button>
                                </div>
                            </div>
                        </div>
                         <div class="container-send-box" v-if="currentVisitorKey!=null">
                            <div class="wrapper">
                                <div class="file-upload">
                                <input multiple type="file" accept=".png, .jpg, .jpeg" @change="uploadImage($event)" id="input-image">
                                    <span v-html="getsvg('upload')"></span>
                                </div>
                            </div>
                            <!-- message suggestions popup -->
                            <div>
                                <button class="bg-transparent border-0" type="button" @click="showSuggestions=!showSuggestions"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M3 3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6V17.4C21 17.7314 20.7314 18 20.4 18H16.2592C16.0938 18 15.9357 18.0683 15.8223 18.1888L12.4369 21.7858C12.2 22.0375 11.8 22.0375 11.5631 21.7858L8.17768 18.1888C8.06429 18.0683 7.90619 18 7.74076 18H3.6C3.26863 18 3 17.7314 3 17.4V3.6Z" stroke="currentColor" stroke-width="1.5"/> <path d="M12 7L13.4254 9.57457L16 11L13.4254 12.4254L12 15L10.5746 12.4254L8 11L10.5746 9.57457L12 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>
                                <div class="suggestions-popup" v-if="showSuggestions">
                                    <div class="suggestions-box">
                                        <div class="suggestion" v-for="(item,index) in suggestions" :key="index">
                                            <div class="flex items-center">
                                                <button  @click="suggestions.splice(index,1)" class="p-2 bg-white text-danger">&times;</button>
                                                <span class="suggestion-text">{{ item }}</span>
                                            </div>
                                            <button type="button" @click="message=item;sendMessage('text');showSuggestions=false">{{ 'Send' }}</button>

                                        </div>
                                        <!-- Add new -->
                                        <form @submit.prevent="suggestions.push(newSuggestion)" class="add-new">
                                            <input type="text" v-model="newSuggestion" :placeholder="'Add new'">
                                            <button type="button" @click="suggestions.push(newSuggestion);newSuggestion=''">{{ 'Add' }}</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <span class="intra-space"></span>
                            <form class="message-send-box">


                                <input class="message-send" dir="auto" type="text" v-model="message" :placeholder="'livechat_typeAMessage'" />
                                <span class="intra-space"></span>
                                <button @click.prevent="sendMessage('text')" class="send-button ">
                                    <span v-html="getsvg('sendBtn')"></span>
                                    <div v-if="cdnloader" class="loader"></div>
                                </button>
                            </form>
                            <span  class="intra-space"></span>
                            <button v-if="recordState=='send'" @click="removeRecord()" class="send-button remove-audio" >
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" style="color:#EF6868" viewBox="0 0 24 24" stroke="currentColor">
                                <path  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                              <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0" fill="#ef6868" data-original="#000000" style=""/><path xmlns="http://www.w3.org/2000/svg" d="m176.8125 351.1875c-4.097656 0-8.195312-1.554688-11.308594-4.691406-6.25-6.25-6.25-16.382813 0-22.632813l158.398438-158.402343c6.253906-6.25 16.386718-6.25 22.636718 0s6.25 16.382812 0 22.636718l-158.402343 158.398438c-3.15625 3.136718-7.25 4.691406-11.324219 4.691406zm0 0" fill="#ef6868" data-original="#000000" style=""/><path xmlns="http://www.w3.org/2000/svg" d="m335.1875 351.1875c-4.09375 0-8.191406-1.554688-11.304688-4.691406l-158.398437-158.378906c-6.253906-6.25-6.253906-16.382813 0-22.632813 6.25-6.253906 16.382813-6.253906 22.632813 0l158.398437 158.398437c6.253906 6.25 6.253906 16.382813 0 22.632813-3.132813 3.117187-7.230469 4.671875-11.328125 4.671875zm0 0" fill="#ef6868" data-original="#000000" style=""/></g></svg> -->
                            </button>
                            <div v-if="recordState=='send'" class="timer-container">
                                <span class="timer-circle"></span>
                                <span class="timer"> {{recordTimer.minutes +':'+ recordTimer.seconds}} </span>
                            </div>
                            <button id="record-button" @click="record()" class="send-button" :class="{'bs2b':recordState=='send'}">
                                <svg v-if="recordState=='send'" id="record-svg" width="16" height="12" viewBox="0 0 16 12" fill="#61AFC7" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M5.52501 11.657L0.575012 6.70699L1.78203 5.49997L5.35453 8.99847L5.49832 9.14526L14.167 0.499969L15.424 1.75699L6.93901 10.243L5.52601 11.656L5.52501 11.657Z"/>
                                </svg>
                                <svg v-else style="fill:#4F5458;" id="record-svg" viewBox="0 0 24 24" width="24" height="24" class=""><path d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"></path></svg>
                            </button>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Warhouses from "../../components/Dropdowns/Warhouses.vue";
import Message from './components/Message.vue'
const recordAudio = () => {
    return new Promise(resolve => {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          const mediaRecorder = new MediaRecorder(stream);
          var audioChunks = [];
  
          mediaRecorder.addEventListener("dataavailable", event => {
            audioChunks.push(event.data);
          });
  
          const start = () => {
            mediaRecorder.start();
          };
          const stop = () => {
            return new Promise(resolve => {
              mediaRecorder.addEventListener("stop", () => {
                const audioBlob = new Blob(audioChunks,{type: 'audio/mp3'});
                const audioUrl = URL.createObjectURL(audioBlob);
                const audio = new Audio(audioUrl);
                audioChunks=[]
                const play = ()=>{
                    audio.play()
                }
                resolve({ audioBlob, audioUrl,audio, play });
              });
              mediaRecorder.stop();
            });
          };
  
          resolve({ start, stop });
        });
    });
  };
export default {
    components:{Message,Warhouses},
    data(){
        return{
                showSuggestions: false,
                newSuggestion: '',
                suggestions: JSON.parse(localStorage.getItem('suggestions')) || ['Hello', 'Hi', 'How can i help you ?'],
                recordTimer:{minutes:'00',seconds:'00'},
                messageOptions:false,
                recordTime:0,
                cdnloader:false,
                audiosrc:null,
                imageCdnLoaded:false,
                responsive:false,
                nofification:null,
                recorder:null,
                recordState:'start',
                imageFull:null,
                uploadedImages:[],
                visitorsSearchKey:"",
                messagesSearchKey:"",
                popIsShowed:false,
                chatIsShowed:true,
                warehouse:null,
                adminName:null,
                App: null,
                visitors: [],
                currentVisitor: "",
                currentVisitorKey: null,
                messages: [],
                message: "",
                audio: null,
                currentMessages: [],
                currentMessagesRes: [],
                responsive: true,
                searchKey: "",
                currentVisitors: [],
                intervalTime:null,
                checkedFilter:true,
                step:0,
                userData:null
       }
    },
    async mounted(){
           this.warehouse =  await this.$store.state.wharhouse.warehousesUser.find(x=>x.country==this.$store.state.wharhouse.warhouseSelected)
         if(this.warehouse){
             delete this.warehouse.__v;delete this.warehouse.createdAt; delete this.warehouse.isDeleted; delete this.warehouse.info; delete this.warehouse.fullOf;
         }
         this.userData=await this.$me
         if(this.userData.content.type==="Admin"){
             this.importfarebase()
            this.adminName = this.userData.content.fullName?this.userData.content.fullName:this.userData.content.email
         }else{
             this.$router.push("/")
         }
    },
    methods: {
        importfarebase(){
            let firebasecdn = document.createElement('script')
            let databasecdn = document.createElement('script')
            let fbauthcdn = document.createElement('script')
            let cryptoAES = document.createElement('script')
            firebasecdn.src = "https://www.gstatic.com/firebasejs/7.17.1/firebase-app.js"
            databasecdn.src = "https://www.gstatic.com/firebasejs/7.17.1/firebase-database.js"
            fbauthcdn.src = "https://www.gstatic.com/firebasejs/7.17.1/firebase-auth.js"
            cryptoAES.src = "https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/aes.js"
            document.head.appendChild(firebasecdn)
            this.nofification = new Audio(require('../../assets/ringtone/sound.mp3'))
            firebasecdn.onload= ()=>{
                document.head.appendChild(databasecdn)
                this.step+=1
            }
            databasecdn.onload= ()=>{
                document.head.appendChild(fbauthcdn)
                this.step+=1
            }
            fbauthcdn.onload= ()=>{
                document.head.appendChild(cryptoAES)
                this.step+=1
            }
            cryptoAES.onload= ()=>{
                this.step+=1
            }
        },   
        async getwharhouseId(){
            await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warehouseSelected,}).then((res) => {this.warehouse=res;})
        }, 
        async init(){
            let decryptedPack = {}
            let fbdecryptedPack = {}

                 decryptedPack = {
                    email: "shipsen105@gmail.com",
                    password: "123456789"
                }
                fbdecryptedPack={
                    apiKey: "AIzaSyA0qVQZaLFUAN-8SFmh4FZuh8eHtgbgJeo",
                    authDomain: "livechat-shipsen.firebaseapp.com",
                    projectId: "livechat-shipsen",
                    storageBucket: "livechat-shipsen.appspot.com",
                    messagingSenderId: "985414755139",
                    databaseURL: "https://livechat-shipsen-default-rtdb.firebaseio.com",
                    appId: "1:985414755139:web:fa32eca49254dc49f905f6",
                    measurementId: "G-0TP8LJ5KM8"
                }



            //    decryptedPack = {
            //         email: "hamzaallaa00@gmail.com",
            //         password: "123456789hamza"
            //     }
            //     fbdecryptedPack = {
            //         apiKey: "AIzaSyBdDbyg1jKYfvAqQln6ape8pRmqp7vh7lU",
            //         authDomain: "livechatshipsen.firebaseapp.com",
            //         projectId: "livechatshipsen",
            //         storageBucket: "livechatshipsen.appspot.com",
            //         messagingSenderId: "137527517238",
            //         databaseURL: "https://livechatshipsen-default-rtdb.firebaseio.com",
            //         appId: "1:137527517238:web:772351e906e652d055b897",
            //         measurementId: "G-JF8TFYMY5Q"
            //     };       
            await this.getfirebase(fbdecryptedPack)
            this.App = firebase   
            return new Promise(resolve => {
                firebase.auth().signInWithEmailAndPassword(decryptedPack.email,decryptedPack.password)
                    .then((userCredential) => {
                        var user = userCredential.user;
                    })
                    .catch((error) => console.log(error));
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {  
                        this.firebaseUserId =user.uid;
                        resolve(user.uid);
                    } else {}
                });
            });           
        },
        getFlug(countrie) {
            const flags = require('../../assets/flags/countries.json');
            let flag = null;
            let dataCountrie = _.find(flags, { 'isoAlpha2': countrie.toUpperCase() });
            if (typeof dataCountrie != "undefined") flag = dataCountrie.flag;
            return flag;
        },
        async record(){
           try {
                switch(this.recordState){
                case 'start':{
                    this.recorder = await recordAudio();
                    await this.recorder.start();
                    document.querySelector('#record-svg').style.fill="#FFF"
                    document.querySelector('#record-button').classList.add("record-animation")
                    var start = new Date().getTime();
                    this.intervalTime = setInterval(()=>{
                        let distance = (new Date().getTime() - start )
                        let minutes = Math.floor(distance/(1000*60))
                        let seconds = Math.floor((distance/1000)-(minutes*60))
                        minutes = minutes < 10 ? '0'+minutes:minutes
                        seconds = seconds < 10 ? '0'+seconds:seconds
                        this.recordTimer={minutes:minutes,seconds:seconds}
                    } ,1000);
                    this.recordState="send"
                    break
                }
                case 'send':{
                    clearInterval(this.intervalTime)
                    this.recordTimer.minutes='00'
                    this.recordTimer.seconds='00'
                    const audio = await this.recorder.stop();
                    this.recorder = await recordAudio();
                    this.audio = await this.audioToBase64(audio.audioBlob)
                    document.querySelector('#record-svg').style.fill="#4F5458"
                    document.querySelector('#record-button').classList.remove("record-animation")
                    this.recordState="start"
                    this.sendMessage('audio')  
                    break
                }
            }
           } catch (error) {
               console.log(error);
           }
        },
        async removeRecord(){
            try {
                clearInterval(this.intervalTime)
                this.recordTimer.minutes='00'
                this.recordTimer.seconds='00'
                const audio = await this.recorder.stop();
                this.recorder=null
                document.querySelector('#record-svg').style.fill="#4F5458"
                document.querySelector('#record-button').classList.remove("record-animation")
                this.audio=null
                this.recordState="start"
            } catch (error) {
                console.log(error);
            }
        
        },     
        audioToBase64(blob) {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise(resolve => {
                reader.onloadend = () => {
                resolve(reader.result);
                };
            });
        },
        showImg(src){
        this.imageFull=src
        },
        closePopImg(){
         this.uploadedImages=[]
        },
        closePop(){
          this.popIsShowed=false
        },
        showConfiguration(){
           this.popIsShowed=true
        },
        showMessageOptions(){
           this.messageOptions=false
        },
        async deleteMessage(item){
            try {
                 item.isDeleted=true
                 await this.App.database()
                .ref(`messages/${item.parentKey}/${item.key}`).set(item);
                // this.currentVisitors.find((x) => x.key === item.parentKey).lastMessage = "";

            } catch (error) {
                console.log(error);
            }
        },
        async startConversation(not=true){
            this.currentVisitors = []
            this.currentVisitorsKeys = []
            this.messages = []
            try {
                await this.App.database() //launch visitors
                    .ref("visitors").orderByChild("lastMessageTime").limitToLast(90)
                    .on("child_added", (snap) => {
                        this.newVisitor(JSON.stringify(snap.val()),JSON.stringify(snap.ref.key),not)
                    });
            } catch (err) {
                console.log(err)
            }
        },
        async newVisitor(data,key,not) {
            data= JSON.parse(data)
            key= JSON.parse(key)
            this.currentVisitorsKeys.push(key);   
            this.visitors.push({
                key: key,
                data: data,
                count: 0,
                lastMessage:{},
                lastMessageTime: data.timestamp,
            });
            this.currentVisitors.push({
                key: key,
                data: data,
                count: 0,
                lastMessage: {},
                lastMessageTime: data.timestamp,
            });
            this.messages.push({
                    key: key,
                    data: [],
            });
            this.visitors.sort((a, b) => (a.lastMessageTime < b.lastMessageTime ? 1 : -1));
            this.currentVisitors.sort((a, b) => (a.lastMessageTime < b.lastMessageTime ? 1 : -1)); 
            await this.App.database() // launch messages
                .ref("messages/" + key)
                .on("child_added", (snap) => {
                    this.newMessage(JSON.stringify(snap.val()),JSON.stringify(snap.ref.parent.key),snap.ref.key,not);
                });
            await this.App.database() // launch messages
                .ref("visitors/")
                .on("child_changed", (snap) => {
                    this.currentVisitors.find((x) => x.data.username === snap.val().username).data.done = snap.val().done;
                });
        },
        newMessage(data,parentKey,key,not) {
            parentKey = JSON.parse(parentKey)
            data= JSON.parse(data)
            if (this.messages.find((x) => x.key === parentKey)) {
                this.messages.find((x) => x.key === parentKey).data.push({...data, key: key,parentKey: parentKey});
                if (!data.admin && !data.readedByAdmin) {
                   if(not) this.nofification.volume = 0.1;
                   if(not) this.nofification.play()
                    this.currentVisitors.find((x) => x.key === parentKey).count += 1;
                    this.visitors.find((x) => x.key === parentKey).count += 1;
                }
            } else {
                this.messages.push({
                    parentKey: parentKey,
                    key: key,
                    data: [data],
                });
            }
            //up date last message
            this.currentVisitors.find((x) => x.key === parentKey).lastMessage.msg = data.type==='text' ? data.message:data.type;
            this.currentVisitors.find((x) => x.key === parentKey).lastMessage.fromAdmin = data.admin ? true : false;
            this.currentVisitors.find((x) => x.key === parentKey).lastMessageTime = data.timestamp;
            this.currentVisitors.sort((a, b) => (a.lastMessageTime < b.lastMessageTime ? 1 : -1));
            this.visitors.find((x) => x.key === parentKey).lastMessage.msg =data.type==='text'?data.message:data.type;
            this.visitors.find((x) => x.key === parentKey).lastMessageTime = data.timestamp;
            this.visitors.sort((a, b) => (a.lastMessageTime < b.lastMessageTime ? 1 : -1));
            if( data.warehouse)  this.currentVisitors.find((x) => x.key === parentKey).data.warehouse = data.warehouse
            //  this.currentVisitors.find((x) => x.key === parentKey).data.done = false

        },
        getfirebase(firebaseConfig) { 
            return new Promise(async(resolve) => {
              try{
                  if (firebase.apps.length > 0) {} else {
                      await firebase.initializeApp(firebaseConfig)
                  }
                  resolve({ firebase });
              }catch(err){
                  console.log("Err--------- : ",err);
              }
            });
     
        },
        async openVisitor(key) {
            this.responsive = true
            this.currentMessages = [];
            key= JSON.parse(key)
            this.currentVisitorKey = key;
            if (this.messages.find((x) => x.key === key)) {
                this.currentMessages = this.messages.find((x) => x.key === key).data;                  
                this.currentMessagesRes = this.messages.find((x) => x.key === key).data;
            }
            if(this.currentVisitors.find((x) => x.key == key).userStores && this.currentVisitors.find((x) => x.key == key).userData){
                this.currentVisitor = this.currentVisitors.find((x) => x.key == key)
            }else{
                let userData = this.userData
                const array = this.currentVisitors.find((x) => x.key == key)
                array.userData = userData
                this.currentVisitor =this.currentVisitors.find((x) => x.key == key)
            }
            this.currentVisitor.count = 0
            this.App.database()
                .ref("messages/" + key)
                .orderByChild("readedByAdmin")
                .equalTo(false)
                .once("value", (results) => {
                    results.forEach((snapshot) => {
                        snapshot.ref.update({
                            readedByAdmin: true
                        });
                    });
                });
                this.messagesSearchKey=""
        
        },
        conversationTerminer(key){
            var visitor=this.currentVisitors.find((x) => x.key == key).data.done
            this.App.database()
                .ref("visitors/" + key)
                .update({
                    done:visitor?!visitor:true
                });
        },
        messagesReaded(key){
            if(!key) return 0
            this.currentVisitor.count = 0
            this.App.database()
                .ref("messages/" + key)
                .orderByChild("readedByAdmin")
                .equalTo(false)
                .once("value", (results) => {
                    results.forEach((snapshot) => {
                        snapshot.ref.update({
                            readedByAdmin: true
                        });
                    });
                });
        },
        sendMessage(messageType) {
            switch (messageType){
               case 'image' :{
                    this.uploadedImages.forEach(async(ele)=>{
                       this.cdnloader=true
                       let img = await this.getImageCDN(ele)
                       this.cdnloader=false
                       this.sendMessage2(messageType,img)  
                   })
                   this.uploadedImages = [];
                   break;
               }
               case 'text' :{
                   if(this.message.length<1){
                       return 0
                    }
                    this.sendMessage2(messageType,this.removeTags(this.message)) 
                    this.message = "";
                    break;
               }
               case 'audio' :{
                    let x = async()=>{
                        this.cdnloader=true
                        let cdnres = await this.getAudioCDN(this.audio)
                        this.sendMessage2(messageType,cdnres)  
                        this.audio=null
                        this.cdnloader=false
                    }
                    x();
                    break;
               }
             }
        },
        async sendMessage2(type,msg){
            await this.App.database()
                .ref("messages/" + this.currentVisitorKey)
                .push({
                    type:type,
                    message:msg,
                    admin: true,
                    from: "admin",
                    warehouse:this.warehouse,
                    to: this.currentVisitorKey,
                    adminName:this.adminName,
                    timestamp: { '.sv': 'timestamp' },
                    readedByVisitor: false,
                    readedByAdmin: true,
                    isDeleted:false
                });
        },
        removeTags(text){
            return text.replace(/(<([^>]+)>)/ig, "");
        },
        getsvg(name) {
            if (name == "home") {
              return `<svg id="light" enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="30px" height="30px" xmlns="http://www.w3.org/2000/svg"> <g>
                            <path stroke-width="14" width="30" height="30" fill="#8b9198" d="m19.5 24h-4c-.276 0-.5-.224-.5-.5v-7c0-.276-.224-.5-.5-.5h-5c-.276 0-.5.224-.5.5v7c0 .276-.224.5-.5.5h-4c-.827 
                               0-1.5-.673-1.5-1.5v-9.5h-2c-.551 0-1-.449-1-1 0-.265.108-.525.296-.713l11.354-11.144c.194-.19.506-.19.7 0l11.35 11.14c.192.192.3.452.3.717 0 .551-.449 1-1 1h-2v9.5c0 .827-.673 1.5-1.5 1.5zm-3.5-1h3.5c.276 0 .5-.224.5-.5v-10c0-.276.224-.5.5-.5h2.5l-11-10.799-11 10.796 2.5.003c.276 0 .5.224.5.5v10c0 .276.224.5.5.5h3.5v-6.5c0-.827.673-1.5 1.5-1.5h5c.827 0 1.5.673 1.5 1.5z"/>
                          </g>
                        </svg>`;}
            if (name == "user") {
                return `<svg id="Capa_1" enable-background="new 0 0 512 512" height="40px" width="40px" viewBox="0 0 512 512"  xmlns="http://www.w3.org/2000/svg"><g><g><g><path fill="#FFF" d="m256.025 483.334 101.429-25.614c57.895-48.074 94.771-120.586 94.771-201.719 0-125.144-87.711-229.801-205.012-255.852-137.316 4.631-247.213 117.407-247.213 255.851 0 71.112 29 135.446 75.812 181.836z" fill="#cbe2ff"/></g><g><path fill="#FFF" d="m446.914 256c0 83.915-40.381 158.391-102.765 205.079l92.031-23.241c46.815-46.39 75.82-110.724 75.82-181.838 0-141.385-114.615-256-256-256-11.024 0-21.886.698-32.543 2.05 126.019 15.988 223.457 123.59 223.457 253.95z" fill="#bed8fb"/></g><g><g><g><path d="m319.621 96.952c0-13.075-10.599-23.674-23.674-23.674h-81.582c-30.091 0-54.485 24.394-54.485 54.485v60.493h192.209v-59.635c0-13.075-10.599-23.674-23.674-23.674h-.798c-4.416 0-7.996-3.579-7.996-7.995z" fill="#365e7d"/><path d="m328.415 104.947h-.798c-4.416 0-7.996-3.58-7.996-7.996 0-13.075-10.599-23.674-23.674-23.674h-8.945v114.978h65.086v-59.635c.001-13.073-10.599-23.673-23.673-23.673z" fill="#2b4d66"/><path d="m425.045 372.355c-6.259-6.182-14.001-10.963-22.79-13.745l-69.891-22.128-76.348-2.683-76.38 2.683-69.891 22.128c-23.644 7.486-39.713 29.428-39.713 54.229v19.094c44.789 47.328 107.451 77.568 177.183 79.92 78.128-17.353 143.129-69.576 177.83-139.498z" fill="#4a80aa"/><path d="m441.968 431.932v-19.094c0-17.536-8.04-33.635-21.105-44.213-37.111 75.626-110.422 130.268-197.346 141.317 10.492 1.329 21.178 2.038 32.026 2.057 10.423-.016 20.708-.62 30.824-1.782 61.031-7.212 115.485-35.894 155.601-78.285z" fill="#407093"/><path d="m261.796 508.168c15.489-30.751 55.822-118.067 44.321-172.609l-50.101-19.499-50.148 19.5c-11.856 56.225 31.37 147.277 45.681 175.29 3.442-.826 6.859-1.721 10.247-2.682z" fill="#e4f6ff"/><path d="m288.197 483.789-20.314-79.917h-23.767l-20.264 79.699 25.058 27.897c6.361-1.457 12.634-3.146 18.81-5.057z" fill="#e28086"/><path d="m249.302 511.905c2.075.054 4.154.091 6.241.095 2.415-.004 4.822-.046 7.222-.113l12.907-14.259c-10.159 3.564-20.61 6.506-31.309 8.779z" fill="#dd636e"/><g><g><g><g><g><g><g><g><path d="m298.774 328.183v-45.066h-85.58v45.066c0 23.632 42.79 49.446 42.79 49.446s42.79-25.814 42.79-49.446z" fill="#ffddce"/></g></g></g></g></g></g></g><path d="m352.089 180.318h-16.359c-9.098 0-16.473-7.375-16.473-16.473v-9.015c0-11.851-11.595-20.23-22.847-16.511-26.243 8.674-54.579 8.676-80.823.006l-.031-.01c-11.252-3.717-22.845 4.662-22.845 16.512v9.019c0 9.098-7.375 16.473-16.473 16.473h-16.358v26.938c0 6.883 5.58 12.464 12.464 12.464 2.172 0 3.939 1.701 4.076 3.869 2.628 41.668 37.235 74.654 79.565 74.654 42.33 0 76.937-32.986 79.565-74.654.137-2.167 1.904-3.869 4.076-3.869 6.883 0 12.464-5.58 12.464-12.464v-26.939z" fill="#ffddce"/><path d="m335.73 180.318c-9.098 0-16.473-7.375-16.473-16.473v-9.015c0-11.851-11.595-20.23-22.847-16.511-3.108 1.027-6.247 1.923-9.407 2.707v88.972c-.438 28.948-16.3 54.142-39.725 67.758 2.861.311 5.763.486 8.706.486 42.33 0 76.937-32.986 79.565-74.654.137-2.167 1.904-3.869 4.076-3.869 6.883 0 12.464-5.58 12.464-12.464v-26.938h-16.359z" fill="#ffcbbe"/></g><g fill="#f4fbff"><path d="m213.194 316.06-33.558 27.267 35.192 43.513c4.281 4.168 11.019 4.424 15.605.594l26.465-22.107z"/><path d="m298.79 316.06-41.892 49.267 24.874 21.268c4.557 3.896 11.327 3.7 15.651-.453l34.94-42.815z"/></g></g><path d="m213.194 316.06-49.256 24.199c-3.75 1.842-5.256 6.404-3.341 10.117l9.65 18.71c2.501 4.848 1.578 10.756-2.282 14.61-1.987 1.983-4.139 4.131-6.004 5.993-3.338 3.332-4.537 8.255-3.067 12.737 11.651 35.517 67.725 89.828 88.946 109.478 1.427.038 2.857.064 4.29.08-15.389-29.933-69.922-143.655-38.936-195.924z" fill="#365e7d"/><path d="m344.019 383.695c-3.861-3.854-4.783-9.762-2.282-14.61l9.65-18.71c1.915-3.713.409-8.275-3.341-10.117l-49.256-24.198c30.978 52.255-23.517 165.929-38.923 195.9 1.448-.025 2.893-.061 4.335-.109 21.265-19.695 77.248-73.94 88.888-109.424 1.47-4.482.271-9.405-3.067-12.737-1.865-1.863-4.017-4.012-6.004-5.995z" fill="#365e7d"/><path d="m256.898 365.327-26.06 21.764 13.278 16.781h23.767l13.279-17.771z" fill="#dd636e"/></g></g></g></g></svg>
           `;}
            if (name == "upload") {
                    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" style="margin-top:2px" version="1.1" width="26" height="26" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m432 0h-352c-44.113281 0-80 35.886719-80 80v280c0 44.113281 35.886719 80 80 80h273c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20h-73.664062l-45.984376-59.65625 145.722657-185.347656 98.097656 108.421875c5.546875 6.136719 14.300781 8.21875 22.019531 5.246093 7.714844-2.976562 12.808594-10.394531 12.808594-18.664062v-170c0-44.113281-35.886719-80-80-80zm40 198.085938-79.167969-87.503907c-3.953125-4.371093-9.640625-6.785156-15.523437-6.570312-5.886719.207031-11.386719 2.996093-15.03125 7.628906l-154.117188 196.023437-52.320312-67.875c-3.785156-4.910156-9.636719-7.789062-15.839844-7.789062-.003906 0-.007812 0-.011719 0-6.203125.003906-12.058593 2.886719-15.839843 7.804688l-44.015626 57.21875c-6.734374 8.757812-5.097656 21.3125 3.65625 28.046874 8.757813 6.738282 21.3125 5.097657 28.050782-3.65625l28.175781-36.632812 88.816406 115.21875h-148.832031c-22.054688 0-40-17.945312-40-40v-280c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m140 72c-33.085938 0-60 26.914062-60 60s26.914062 60 60 60 60-26.914062 60-60-26.914062-60-60-60zm0 80c-11.027344 0-20-8.972656-20-20s8.972656-20 20-20 20 8.972656 20 20-8.972656 20-20 20zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m468.476562 302.941406c-.058593-.058594-.117187-.121094-.175781-.179687-9.453125-9.519531-22.027343-14.761719-35.410156-14.761719-13.34375 0-25.882813 5.210938-35.324219 14.675781l-38.613281 38.085938c-7.863281 7.753906-7.949219 20.417969-.191406 28.28125 7.753906 7.863281 20.417969 7.953125 28.28125.195312l25.847656-25.492187v112.253906c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-111.644531l24.738281 25.554687c3.921875 4.054688 9.144532 6.089844 14.371094 6.089844 5.011719 0 10.027344-1.871094 13.910156-5.628906 7.9375-7.683594 8.140625-20.34375.457032-28.28125zm0 0" fill="#7e7e7e" data-original="#000000" style="" class=""/></g></svg>
           `;}
            if (name == "sendBtn") {
                return `<svg viewBox="0 0 24 24" width="22" height="22" class=""><path fill="#4F5458" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg>
           `;}
            if (name == "recordBtn") {
                return `<svg viewBox="0 0 24 24" width="24" height="24" class=""><path fill="#4F5458" d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"></path></svg>
           `;}     
             if (name == "removeUser") {
                return `<svg height="30px" viewBox="0 0 455 455.5" width="30px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <linearGradient id="a"><stop offset=".322" stop-color="#a163f5"/><stop offset=".466" stop-color="#b074ee"/><stop offset=".752" stop-color="#d8a1dd"/><stop offset=".898" stop-color="#efbad3"/>
                        </linearGradient><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="169.550426" x2="169.550426" xlink:href="#a" y1="427.5" y2="50.2759"/>
                        <linearGradient id="c" gradientUnits="userSpaceOnUse" x1="354.550426" x2="354.550426" xlink:href="#a" y1="427.5" y2="50.2759"/>
                        <linearGradient id="d" gradientUnits="userSpaceOnUse" x1="388.750426" x2="388.750426" xlink:href="#a" y1="427.5" y2="50.2759"/>
                        <linearGradient id="e" gradientUnits="userSpaceOnUse" x1="320.450426" x2="320.450426" xlink:href="#a" y1="427.5" y2="50.2759"/>
                        <linearGradient id="f" gradientUnits="userSpaceOnUse" x1="227.403026" x2="227.403026" xlink:href="#a" y1="427.5" y2="50.2759"/>
                        <path fill="#8b9198" d="m169.550781 211.398438c58.398438 0 105.699219-47.296876 105.699219-105.699219 0-58.398438-47.300781-105.699219-105.699219-105.699219-58.398437 0-105.699219 47.300781-105.699219 105.699219.097657 58.402343 47.300782 105.601562 105.699219 105.699219zm0-191.398438c47.300781 0 85.699219 38.398438 85.699219 85.699219s-38.398438 85.699219-85.699219 85.699219-85.699219-38.398438-85.699219-85.699219c.097657-47.300781 38.398438-85.597657 85.699219-85.699219zm0 0"/>
                        <path fill="#8b9198" d="m354.550781 355.398438c-5.5 0-10 4.5-10 10v45.101562c0 5.5 4.5 10 10 10s10-4.5 10-10v-45.101562c0-5.5-4.5-10-10-10zm0 0"/>
                        <path fill="#8b9198" d="m388.75 355.398438c-5.5 0-10 4.5-10 10v45.101562c0 5.5 4.5 10 10 10s10-4.5 10-10v-45.101562c0-5.5-4.5-10-10-10zm0 0"/>
                        <path fill="#8b9198" d="m320.449219 355.398438c-5.5 0-10 4.5-10 10v45.101562c0 5.5 4.5 10 10 10s10-4.5 10-10v-45.101562c0-5.5-4.5-10-10-10zm0 0"/>
                        <path fill="#8b9198" d="m425.851562 246.5h-25.902343v-20.898438c0-9.101562-7.296875-16.402343-16.398438-16.402343h-57.898437c-9.101563 0-16.402344 7.300781-16.402344 16.402343v20.898438h-25.898438c-10.101562 0-19.402343 5.300781-24.601562 13.898438-26.699219-16.597657-57.597656-25.296876-89-25.199219h-.300781c-45.796875.101562-88.296875 17.902343-119.796875 50.300781-32 32.699219-49.5 77.398438-49.402344 125.898438 0 5.5 4.5 10 10 10l260.300781-.5v3.300781c0 17.300781 14 31.300781 31.300781 31.300781h105.398438c17.300781 0 31.300781-14 31.300781-31.300781v-123.199219c14.199219-7 20.101563-24.300781 13-38.5-4.800781-9.800781-14.800781-16-25.699219-16zm-96.699218-17.300781h50.796875v17.300781h-50.796875zm-45.800782 37.300781h142.5c4.800782 0 8.699219 3.898438 8.699219 8.699219 0 2.902343-1.398437 5.601562-3.800781 7.199219-.699219-.199219-1.5-.296876-2.199219-.296876-2.101562 0-4.101562.699219-5.800781 1.796876h-136.398438c-1.699218-1.199219-3.699218-1.796876-5.800781-1.796876-.699219 0-1.5.097657-2.199219.296876-4-2.699219-5-8.097657-2.300781-12.097657 1.699219-2.402343 4.398438-3.800781 7.300781-3.800781zm-262.800781 134.800781c2.101563-39.300781 17.398438-75.199219 43.398438-101.902343 27.703125-28.5 65.203125-44.199219 105.5-44.199219h.300781c30.699219-.199219 60.699219 9.300781 85.699219 27 2.101562 8.101562 7.601562 14.902343 15.101562 18.699219v99.902343zm386.699219 34.199219h-105.300781c-6.199219 0-11.296875-5-11.296875-11.300781v-120.199219h128v120.199219c-.101563 6.199219-5.203125 11.199219-11.402344 11.300781zm0 0"/>
                        </svg>`
            ;}
            if (name == "dropDownIco") {
                return `<svg viewBox="0 0 24 24" height="23" width="23" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none; display: block; "><g class="style-scope yt-icon"><polygon points="18.4,14.6 12,8.3 5.6,14.6 6.4,15.4 12,9.7 17.6,15.4 " class="style-scope yt-icon"></polygon></g></svg>`
            ;}
            if (name == "config") {
                return `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" x="0px" y="0px"
                viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <g>
                    <g>
                        <path fill="#8b9198" d="M512,317.379V194.621l-47.232-7.229c-3.435-10.451-7.665-20.65-12.644-30.486l28.296-38.524l-86.803-86.803
                            l-38.524,28.296c-9.836-4.979-20.035-9.208-30.486-12.644L317.379,0H194.621l-7.229,47.232
                            c-10.451,3.435-20.65,7.665-30.486,12.644L118.382,31.58l-86.803,86.803l28.296,38.524c-4.979,9.836-9.208,20.035-12.644,30.486
                            L0,194.621v122.758l47.232,7.229c3.435,10.451,7.665,20.65,12.644,30.486L31.58,393.618l86.803,86.803l38.524-28.296
                            c9.836,4.978,20.035,9.208,30.486,12.644L194.621,512h122.758l7.229-47.232c10.451-3.435,20.65-7.665,30.486-12.644l38.524,28.296
                            l86.803-86.803l-28.296-38.524c4.978-9.836,9.208-20.035,12.644-30.486L512,317.379z M441.327,297.847l-2.606,9.325
                            c-4.065,14.545-9.9,28.617-17.345,41.824l-4.756,8.438l24.374,33.185l-50.376,50.376l-33.185-24.374l-8.438,4.756
                            c-13.207,7.444-27.279,13.28-41.824,17.345l-9.325,2.606L291.621,482h-71.242l-6.226-40.673l-9.325-2.606
                            c-14.545-4.065-28.617-9.9-41.824-17.345l-8.438-4.756l-33.185,24.374l-50.376-50.376l24.374-33.185l-4.756-8.438
                            c-7.444-13.207-13.28-27.279-17.345-41.824l-2.606-9.325L30,291.621v-71.242l40.673-6.226l2.606-9.325
                            c4.065-14.545,9.9-28.617,17.345-41.824l4.756-8.438l-24.374-33.185l50.376-50.376l33.185,24.374l8.438-4.756
                            c13.207-7.444,27.279-13.28,41.824-17.345l9.325-2.606L220.379,30h71.242l6.226,40.673l9.325,2.606
                            c14.545,4.065,28.617,9.9,41.824,17.345l8.438,4.756l33.185-24.374l50.376,50.376l-24.374,33.185l4.756,8.438
                            c7.444,13.207,13.28,27.279,17.345,41.824l2.606,9.325L482,220.379v71.242L441.327,297.847z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path fill="#8b9198" d="M256,132.109c-68.314,0-123.891,55.577-123.891,123.891S187.686,379.891,256,379.891S379.891,324.314,379.891,256
                            S324.314,132.109,256,132.109z M256,349.891c-51.771,0-93.891-42.119-93.891-93.891c0-51.772,42.119-93.891,93.891-93.891
                            s93.891,42.119,93.891,93.891S307.772,349.891,256,349.891z"/>
                    </g>
                </g>
                
                </svg>`
            ;}
        },
        getTime(lastMessageTime) {
            let time = null
            let ddate = null
            const diff = Date.now() - lastMessageTime
            const d = diff / (1000 * 60 * 60 * 24)
            const date = new Date(lastMessageTime)
                if (date.getMinutes() < 10) {
                    time = date.getHours() + ":0" + date.getMinutes()
                } else {
                    time = date.getHours() + ":" + date.getMinutes()
                }
            if (d >= 1) {   
                ddate =  date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear()
            }
            return ddate ? ddate+'  '+time : time
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async uploadImage(event) {
                event.target.files.forEach(async(ele) => {
                     await this.getBase64(ele).then(
                            async (data) => {
                                this.uploadedImages.push(data)
                            })
                })          
            },
        async getImageCDN(file){
            try {
                var res=await this.$server.create('medias',{picture:file})
               return res.content.message
            } catch (error) {
                console.log('err',error);
            }
        },
        async changeCheck(key){
            let instance = this.currentVisitors.filter(x=>{
                if(x.key==key){
                    return x
                }
            });
            if(instance.length>0){
                instance[0].data.isMarked=!instance[0].data.isMarked
                await this.App.database().ref(`visitors/${key}/isMarked`).set(instance[0].data.isMarked);
            }
        },
        async getAudioCDN(file){
          try {
                var res=await this.$server.create('medias',{picture:file})
               return res.content.message
            } catch (error) {
                console.log('err',error);
            }
        },
       filterVisitorsInWarehouse(){
            if(!this.checkedFilter){
                this.currentVisitors=[]
                for (const v of this.visitors) {
                    if(v.data.warehouse ){
                         if(v.data.warehouse._id==this.warehouse._id)this.currentVisitors.push(v)
                    }
                }
            }else{
                if(this.step!=5) return false
                this.startConversation(false)
            }
       }
    }, 
    watch: {
        "$store.state.wharhouse": {
            handler(newValue, oldValue) {
                this.warehouse = newValue.warehousesUser.find(x=>x.country==newValue.warhouseSelected)
                delete this.warehouse.__v;delete this.warehouse.createdAt; delete this.warehouse.isDeleted; delete this.warehouse.info; delete this.warehouse.fullOf;
                  this.filterVisitorsInWarehouse()
            },
            deep: true
        },
        // deep watch
        suggestions: {
            handler: function (val, oldVal) {
                window.localStorage.setItem('suggestions', JSON.stringify(val));
            },
            deep: true
        },
        "checkedFilter"(){    
           this.filterVisitorsInWarehouse()
        },
        "visitorsSearchKey" () {
            this.currentVisitors = this.visitors.filter(x =>{
                if(x.data.subdomain){
                    if(x.data.username.includes(this.visitorsSearchKey) || x.data.subdomain.includes(this.visitorsSearchKey) ){
                        return x;   
                    }
                }else{
                    if(x.data.username.includes(this.visitorsSearchKey)){
                        return x;   
                    }
                }
             })
        },
        "messagesSearchKey"(){
            this.currentMessages = this.currentMessagesRes.filter(x =>{
                    if(x.type === 'text' && x.message.includes(this.messagesSearchKey)){
                        return x.message
                    }
            })
        },
        "currentMessages": {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    if (document.getElementById('messages-scroll-box') !== null) {
                        let scrollBox = document.getElementById('messages-scroll-box');
                        scrollBox.scrollTop = scrollBox.scrollHeight;
                    }
                })
            }
        },
        async "step"(){
            if (this.step==4) {
                try {
                    await this.init()
                    this.step=5
                    this.startConversation()
                } catch (error) {
                    
                }
            //     setTimeout(async() => {                
            // },1000)   
            }
        }
    },
   
}
</script>
<style scoped>
.st {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.1)!important;
    border-radius: 20px;
}
form.message-send-box {
    position: relative;
}

.suggestions-popup {
    position: absolute;
    bottom: 46px;
    background: white;
    box-shadow: 0 0 5px 0 #00000088;
    border-radius: 5px;
}
.suggestions-box .add-new{
    display: flex;
    width: 100%;
    padding: 5px;
    background: gainsboro;
}
.suggestions-box .add-new input{
    display: flex;
    flex: 1;
    background-color: whitesmoke;
    border: 0;
    padding: 5px;
}
.suggestions-box .add-new button{
    display: flex;
    background: #29839e;
    border: 0;
    padding: 6px;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    margin: 4px;
}
.suggestion {
    display: flex;
    padding: 5px;
    border-bottom: 1px solid #cfcece;
    min-width: 300px;
    justify-content: space-between;
}

.suggestion button {
    background: #29839e;
    color: white;
    border: 0;
    padding: 6px;
    border-radius: 5px;
    cursor: pointer;
}
.suggestion button:hover {
    background: #2b8cbe;
}

.fade-area-enter-active {
  transition: all .3s ease;
}
.fade-area-leave-active {
  transition: all .6s ease;
}
.fade-area-enter, .fade-area-leave-to{
  transform: translateY(-15px);
  opacity: 0;
} 
.the-footer{
    display: none;
}
.mr-40{
    margin-right: 80px!important;
    transition: all .5s ease;
}
.rotate-180{
    transform: rotate(180deg);
    transition: ease-in-out .4s;
}
.rotate--90{
    cursor:pointer;
    transform: rotate(-90deg);
    transition: ease-in-out .4s;
}

@keyframes record {
    0% { background-color: rgba(95, 146, 155, 0.3); }
    25% { background-color:rgba(163, 227, 238, 0.2); }
    50% { background-color:rgba(238, 238, 238, 0); }
    75% { background-color:rgba(160, 174, 177, 0.2); }
    100% { background-color: rgba(121, 167, 175, 0.3); }
}
@keyframes record-bounce {
  0% { transform: scale(1); opacity: 1 }
  25% { transform: scale(0.8); opacity: .5; }
  50% { transform: scale(0.7); opacity: 0; }
  75% { transform: scale(0.8) ; opacity: .5;}
  100% { transform: scale(1) ; opacity: 1;}
}
@keyframes typing-bounce {
  0% { opacity: 1 }
  25% { opacity: .5; }
  50% { opacity: 0; }
  75% { opacity: .5;}
  100% { opacity: 1;}
}
@keyframes button-loading {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
.record-animation{
    animation: record 2s linear infinite!important;
}
.d-f{
    display: flex;
}
.btn{
    min-width: 100px;
    height: 40px;
    font-size: 16px;
    padding: 0 5px;
    border: none;
    border-radius: 4px;
}
.btn-config{
   background-color: #1c5c7a;
   color: rgb(255, 255, 255);
}
.popup-container{
  -webkit-transition: all .2s;
  transition: all .2s;
  width: 100%;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 70000;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: space-evenly;
  opacity: 1;
  padding: 10px 0;
}
.responsive-back-Box{
    left: 0;
    background-color: rgba(78, 77, 77, 0.4);
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    transition: all .25s ease;
}
.close-icon{
    height: 28px;
    width: 28px;
    border-radius: 50%;
    border: 1px solid rgb(167, 167, 167);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer; 
}
.close-icon:hover{
    background-color: #f6f6f69f;
}
.bar{
    background-color: rgb(23, 40, 54);
    height: 3px;
    width: 17px;
    position: absolute;
}
 .bar:first-child{
    transform: rotate(45deg);
}
 .bar:last-child{
    transform: rotate(-45deg);
}
/*  */
.svg-config {
    cursor: pointer;
    display: flex;
}
.popup{
    -webkit-transition: all .2s;
    transition: all .2s;
    z-index: 100;
    width: 50vw;
    margin:auto 10px;
    max-width: calc(100% - 30px);
    /* max-height: calc(100vh - 30px); */
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    background: #fff;
    -webkit-animation: rebound .4s;
    animation: rebound .4s;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.popup .header{
    padding: 11px 9px ;
    display: flex;
    flex-direction: row!important;
    align-items: center;
    justify-content: space-between;
    background-color: var(--primary-color);
    color: var(--second-color);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    font-size: var(--normal-size);
}
.popup .body{
    padding: 12px 30px;
    display: flex;
    min-height: 40vh;
    max-height: 65vh;
    /* align-items: center; */
    justify-content: space-between;
    overflow-y: auto;
    flex-direction: column;
    position: relative;
}
.popup .footer{
    padding: 8px 6px ;
    display: flex;
    flex-direction: row!important;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-color);
    color: var(--second-color);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    font-size: var(--normal-size);
}
/*  */
.popup section{
    display: flex;
    flex-direction: column;
}
.popup .label{
    font-size: var(--small-size);
    color: var(--second-color);
    margin-bottom: 4px;
}
.content-input{
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 6px 0;
}
.content-input input{
    color: inherit;
    padding: .175rem 1rem .175rem .5rem;
    border-radius: 5px;
    font-size: var(--small-size);
    font-weight: 400;
    line-height: 1.5;
    border: 1px solid rgba(51, 51, 51, 0.2);
    box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
    -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    height: 31px;
    position: relative;
    outline: none;
}

.container-area{
    padding: 0 30px;
}
.chat-container{
      background-color: #FFF;
      border: solid 1px #EAE8F0;
      border-radius: 8px;
      box-shadow: 0 0 1px 2px rgb(238, 238, 238);
}
.chat-container .sub-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 50px;
}
.chat-box {
    border: solid 1px #EAE8F0;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: row;
    position: relative;
    height: calc(100vh - 8.1em);
    width: 100%;
    box-sizing: border-box;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    position: relative;
}
.fake-side{
    background: #f8f8f8;
    position: absolute;
    width: 80vw;
    left: -80vw;
    height: 100%;
    z-index: 100;
    display: none;
}
.hidding-space{
    margin-right: 28px;
    transition:all .5s ease;
    display: none;
}
.chat-box .left-box {
    display: flex;
    flex-direction: column;
    border-right: solid 1px #EAE8F0;
    width: 40%;
}
.left-box .chat-head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px #EAE8F0;
    font-size: 20px;
    padding: 11px 8px;
    position: relative;
}
.search-box {
    border: none;
    display: flex;
    height: 32px;
    margin: 0;
    border-radius: 20px;
    background-color:#f8f8f8 ;
}
.chat-head .search-box{
    width: calc(100% - 60px);
}
.search-box label {
  position: relative;
}
.search-box label:before {
  content: "";
  position: absolute;
  left: 10px;
  top: 4px;
  bottom: 0;
  width: 20px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill-rule='evenodd'%3E%3Cpath d='M16.036 18.455l2.404-2.405 5.586 5.587-2.404 2.404zM8.5 2C12.1 2 15 4.9 15 8.5S12.1 15 8.5 15 2 12.1 2 8.5 4.9 2 8.5 2zm0-2C3.8 0 0 3.8 0 8.5S3.8 17 8.5 17 17 13.2 17 8.5 13.2 0 8.5 0zM15 16a1 1 0 1 1 2 0 1 1 0 1 1-2 0'%3E%3C/path%3E%3C/svg%3E") center / contain no-repeat;
}
.search-box input {
    border: none;
    background: none;
    outline: none;
    padding: 0 0 0 32px;
    font-size: 15px;
    width: 100%;
    height: 100%;
}
.search-box input:focus {
    outline: none;
}
.responsive-icon{
    width: 40px;
    margin-top: -7px;
    display: none;
    position: absolute;
    padding: 8px 5px;
    cursor: pointer;
    transition: all .5s ease;
}
.icon-bar {
    width: 26px;
    height: 3px;
    background-color: #333;
    display: block;
    margin: 4px 0;
}
.left-box .contacts-box {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
}
.contacts-box .contact-box {
    min-height: 50px;
    display: flex;
    padding: 5px 8px;
    align-items: center;
    width: calc(100% - 30px);
}
.contacts-box .contact{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.contacts-box .options{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 50px;
    width:30px
}
.contacts-box .checkbox{
    height: 16px;
    width: 16px;
    border-radius: 50%;
    border:none;
    cursor: pointer;
}
.contacts-box .checkbox.remo{
    height: 16px;
    width: 16px;
    border-radius: 50%;
    border:none;
    cursor: pointer;
    background: rgb(53, 82, 243);
}
.contacts-box .checkbox.marked{
    background:rgb(253 95 95);
}

.contact:hover {
    cursor: pointer;
    background-color: #e2e2e2;
}

.contact-details {
    width: calc(100% - 34px);
    border: none;
    display: flex;
    align-items: center;
flex-direction: row;
justify-content: space-between;
}


.deleted-chat {
    background-color: #ff0101!important;
}

.contact-details .contact-data {
    width: 70%;
    display: inline-flex;
    flex-wrap: wrap;
}

.contact-details .contact-news-box {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.contact-data .contact-name{
    padding-left: 10px;
    font-size: 15px;
    width: calc(100% - 34px);
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.contact-data .contact-name img {
    height: 20px;
    width: 24px;
}

.contact-data .contact-last-message {
    padding-left: 1rem;
    width: calc(100% - 50px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    opacity: .7;
    margin-bottom: 0;
    margin-top: -6px;
    display: flex;
    align-items: center;
}
.contact-last-message span {
    
    height: 21px;
}
.fw-b{
    font-weight: bold;
}

.news-time {
    color: grey;
    font-size: 14px;
    text-align: center;
    display: inline-table;
}

.news-count {
    background-color: #35dd7b;
    border-radius: 50%;
    text-align: center;
    color: #FFFFFF;
    font-size: 14px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.active{
    background-color: #e2e2e2;
    color: #5f5f5f;
}
.active .news-time {
    color: #5f5f5f;
}
.chat-box .right-box {
    position: relative;
    width: 60%;
}

.right-box .visitor-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

}

.right-box .admin-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-right: solid 1px #EAE8F0;
}

.current-chat {
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    border-bottom: solid 1px #EAE8F0;
    font-size: 20px;
    padding: 10px 8px;
}
.padding-left{
    padding-left: 40px;
}
.admin-box .current-chat{
    justify-content: flex-end;
}
.visitor-box .current-chat{
    justify-content: space-between;
}
.flex{
    display: flex;
    justify-self: center;
    align-items: center;
}
.flex-right{
    flex-direction: row-reverse;
}
.current-chat .chat-title {
    display: flex;
    white-space: nowrap;
    font-size: 25px;
    align-items: center;
}
/*  */
.current-chat .client-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.user-info-icon {
       cursor:pointer;
       transform: rotate(180deg);
       background: #e8e8e8;
       border-radius: 50%;
       margin-left:6px;
       padding: 3px;
}
.current-chat .detail-info{
    position: absolute;
    width: calc(80%);
    right: 0;
    top: 2px;
    bottom: 1px;
    z-index: 10;
    transition:all ease 2.5s;
}
.current-chat .detail-info .box{
    background-color: #FFF;
    box-shadow: 0 0 2px 1px rgb(187 178 178);
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 32px 8px 8px 29px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y:auto ;
}
.current-chat .detail-info .box .label{
    margin-left: -15px;
    font-size: 20px;
    }
.current-chat .detail-info  a{
    color: rgb(55, 118, 177)!important;
    font-size:14px;
    display: block;
}
.current-chat .detail-info .box>span:first-child{
    position: absolute;
    left: 4px;
    top: 4px;
    transform: rotate(90deg);
    display: flex;
    align-items: center;
    justify-content: center;
}
.current-chat .detail-info .box .pack{
    margin-bottom: 4px;
    display: flex;
    flex-direction: row;
    /* align-items: center; */
    justify-content: space-between;
}

.current-chat .detail-info  .prop{
    font-size: 15px;
    font-weight: 600!important;
    color: rgb(99, 99, 99);
}
.current-chat .detail-info  .value{
    text-align: left;
    width: calc(100% - 160px);
    font-size: 14px;
    font-weight: 600!important;
    color: rgb(27, 48, 68);
}
.current-chat .detail-info .box .sub-value{
   display: block;
}
.current-chat .detail-info .box .stores{
    margin-bottom: 4px;
    display: flex;
    flex-direction: column;
}
.current-chat .detail-info  .store:last-child hr{
    display: none;
}

.ws-4{
    margin-right: 4px;
}
.current-chat .title-name {    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    font-size: 25px;
    font-size: 17px;
    font-weight: 400;
    line-height: 14px;
    color: #000;
}
.current-chat .title-subdomain {
    min-height: 20px;
    font-size: 14px;
    line-height: 20px;
    color: #00000099;
}
.current-chat .search-box{
    margin-right: 8px;
}
.current-chat .retation:hover {
    -webkit-animation: rotating 3s linear infinite;
}

/*  */
.messages-box {
    background: linear-gradient(to right,#1111110d,#ffffff00),url(https://storeno.b-cdn.net/stores/6-2021/1622561368276.jpeg);
    max-width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    padding: 2px 20px;
    /* margin: 6px 0; */
    border-bottom: solid 1px #EAE8F0;
}
.messages-box .msg{
    position: relative;
}
.messages-box .message-image{
    display: flex;
}
.messages-box .msg.rightfollow{
    justify-content: flex-end;
}
.messages-box .msg.leftfollow{
    justify-content: flex-start;
}
.messages-box .msg .message-options{
    position: absolute;
    left: -12px;
    box-shadow: 0 0 3px 1px #4846463d;
    border-radius: 3px;
    text-align: center;
    padding-top: 4px;
    transition: all .5s ease;
    top: 0;
    z-index: 2;
    height: 30px;
    width: 120px;
    background-color: #FFF;
}
.messages-box .msg img{
    cursor: pointer;
    max-width: 100%;
    max-height: 300px;
    padding: 5px;
}
.messages-box .uploader-image{
    position: absolute;
    display: flex;
    justify-content: space-between;
    bottom: 59px;
    width: calc(100% - 40px);
    height: 175px;
    padding: 8px 8px;
    background-color: #FFF;
    box-shadow: 0 0 2px 1px rgb(175 175 175);
    border-radius: 5px;
}
.images-slied {
    display: flex;
    width: calc(100% - 50px);
    overflow-x: auto;
}

.messages-box .uploader-image .actions{
padding: 5px 0;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: space-between;
}
.uploader-image .actions .send-button-img{
    width: 32px!important;
    height: 32px!important;
    background: none;
}
.messages-box .uploader-image img{
    width: 210px;
    object-fit: contain;  
}


.messages-box form {
    margin: 0;
}

.msg {
    width: 99%;
    height: auto;
    display: flex;
    margin-bottom: 5px;

}
/* ---- */

.container-send-box{
    background-color: #ffffff;
    padding: 8px 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
.message-send-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4px;
     background-color: #f8f8f8;
    border-radius: 25px;
    width: calc(100% - 70px);
}
input.message-send {
    font-size: 15px;
    border: none;
     background-color: #f8f8f8;
    border-radius: 25px;
    padding-left: 12px;
    padding-right: 8px;
    width: 100%;
    height: 35px;
}

input.message-send::placeholder {
    font-weight: 300;
}

input.message-send:focus {
    outline: none;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.wrapper .file-upload {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .5s;
}
.wrapper .file-upload span{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
}
.wrapper .file-upload input[type=file] {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.wrapper:hover {
  box-sizing: 0 2px 2px rgb(216, 54, 54);
  cursor: pointer;
}

  .image-full{
    -webkit-transition: all .2s;
    transition: all .2s;
    width: 100vw;
    min-height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 700000;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: space-evenly;
    opacity: 1;
    padding: 20px 30px;
    box-sizing: border-box;

  }
  .image-full .back-box{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.4);
    position: absolute;
    top: 0;
    min-height: 100vh;
    z-index: 10;
    -webkit-transition: all .25s ease;
    transition: all .25s ease;

  }
  .image-full .img{
    -webkit-transition: all .2s;
    transition: all .2s;
    z-index: 100;
    max-width:90%;
    max-height: 90%;
    margin: auto 10px;
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    background: #fff;
    -webkit-animation: rebound .4s;
    animation: rebound .4s;
    position: relative;
  }
  .image-full .abs-ico{
    position: absolute;
    top: 8px;
    right: 8px;
  }
  .image-full img{
    max-width: 100%;
    max-height: 80vh;
  }
.send-button {
    position: relative;
    overflow: hidden;
    min-width: 31px;
    height: 31px;
    border: none; 
    border-radius: 20px;
    transition: ease .4s;
    background-color: #F8F8F8;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.send-button .loader {
    background: rgb(111 157 174);
    position: absolute;
    z-index: 2;
    height: 30px;
    width: 30px;
    border-radius: 50px;
}
.send-button .loader::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 4px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: button-loading 1s ease infinite;
}
.bs2b{
  border: solid 2px #61AFC7!important
}
.bs2b:hover>svg{
fill:#e8e8e8!important;
}

.bs2b:hover{
  border: solid 2px #ffffff!important;

  background-color: #61AFC7!important;
}
#record-button{
    width: 30px!important;
    height: 31px!important;

}
.remove-audio{
    border: solid 2px #EF6868;
    box-sizing:border-box
}
.remove-audio:hover{
    /* border: solid 2px #fff; */
    background: #EF6868;
}
.remove-audio:hover svg {
    color: #FFF!important;
}

.timer-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:0 4px;
}
.timer{
    text-align: center;
    width: 52px;
    font-size: 14px;
    color: rgb(147 147 147);
    font-weight: 400;
}
.timer-circle{
    width: 13px;
    height: 13px;
    background: rgb(246, 57, 57);
    border-radius: 50%;
    animation: record-bounce 1.2s ease infinite;
}
.focused{
    animation: typing-bounce 1.4s ease infinite;
    color: rgb(106, 230, 123);
}
.intra-space{
    margin-right: 4px;
}
/* global */
*{
    box-sizing: border-box;
}
.pointer{
    cursor: pointer;
    display: flex;
}
.popup-container .back-box {
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    min-height: 100vh;
    z-index: 10;
    transition: all .25s ease;
}
.image-icon{
    height: 40px;
    width: 40px;
    cursor: pointer;
}
.image-icon img{
    height: 100%;
    width: 100%;
}
.profile-image {
    position: relative;
    width: 34px;
    height: 34px;
    cursor: pointer;
}
.profile-image .default-iamge {
    width: 34px;
    height: 34px;
    border-radius: 50%;
        border: 1px solid rgb(145 145 145);
    background-color: rgb(232 232 232);
    display: flex;
    justify-content: center;
    align-items: center;
}
.profile-image img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
}
.profile-image .account-status {
    position: absolute;
    right: 0;
    bottom: 2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #48cf70;
}
.scroll-box::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 #F8F9FD;
    box-shadow: inset 0 0 0 #F8F9FD;
}
.scroll-box::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
.scroll-box::-webkit-scrollbar-thumb {
    border-radius: 1.5rem;
    background-color: #001f3f;
}
.scroll-box::-webkit-scrollbar:hover {
    width: 10px;
}
.hide-siedBar{
    left: -50vw!important;
    bottom: 0;
    height: 100%;
    z-index: 7;
    background: #FFF;
    position: absolute;
    transition: all .3s ease;
}
.show-siedBar{
    left: 0!important;
    bottom: 0;
    height: 100%;
    z-index: 7;
    background: #FFF;
    position: absolute;
    transition: all .3s ease;
}
.check-filter{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
    line-height: inherit;
    color: inherit;
    line-height: inherit;
    color: inherit;
    font-size: 1em;
}
.check-filter-container{
    align-items: center;
    justify-content: center;
    margin-top: auto;
    margin-bottom: auto; 
}
.check-filter-container label{
    display: flex;
    cursor: pointer;
    align-items: center;
    padding-left: 1.25rem
}
.relative{
    position: relative; 
}
.check-filter-c{
    display: block;
    width: 44px;
    border-radius: 9999px;
    height: 22px;  
}
.check-filter-c.bg-color-true{
    background-color: #3182ce; 
}
.check-filter-c.bg-color-false{
    background-color: rgb(203, 203, 203);
}
.check-filter-rounded{
    height: 16px;
    width: 16px;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 9999px;
    top: 0.18rem;
    position: absolute;
    transition:all .5s ease;
    border: none;
    background: rgb(214, 214, 214);
}
.check-filter-rounded.rounded-left{
    transition:all .5s ease;
    left: 0.25rem;
}
.check-filter-rounded.rounded-right{
    transition:all .5s ease;
    right: 0.25rem;
}

@media (max-width:768px){
    .hidding-space{
    display: block;
}
    .fake-side{
        display: block;
    }
    .responsive-icon{
        display: block;
        left: 100%;
        top: 12px;
    }
     .moveleft {
        left: -80%!important;
    }
    .left-box{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0%;
        z-index: 99;
        width: 80%!important;
        background: white;
        transition: all .5s ease
    }
    .chat-box .right-box{
        width: 100%!important;
    }
}
</style>